import React, { Component } from 'react';
import { Modal, Form, Button, Input, Select } from 'antd';
import { inject, observer } from 'mobx-react/index';
const Option = Select.Option;
const ButtonGroup = Button.Group;

@inject('store')
@observer
export class CreatePositionModal extends Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }

    render() {
        return (
            <Modal
                title="Manual Buy"
                visible={this.props.visible}
                onCancel={() => {
                    this.form.current.resetFields();
                    this.props.onCancel();
                }}
                onOk={() => {
                    this.form.current.validateFieldsAndScroll((err, values) => {
                        if (!err) {
                            this.props.store.botStore.actionStore.execute(
                                'manual_limit_buy',
                                values
                            );
                            this.form.current.resetFields();
                            this.props.onCancel();
                        }
                    });
                }}
            >
                <CreatePositionForm ref={this.form} />
            </Modal>
        );
    }
}

@inject('store')
@observer
class CreatePositionFormComponent extends Component {
    renderSelectedSymbolPrice() {
        const { getFieldValue, setFieldsValue } = this.props.form;
        const selectedSymbol = getFieldValue('market_id');

        if (selectedSymbol) {
            const price = this.props.store.botStore.marketStore.getByName(selectedSymbol);

            return (
                <div
                    style={{
                        background: 'rgba(0,0,0,0.2)',
                        padding: 5,
                        borderRadius: 2,
                        marginTop: 5
                    }}
                >
                    Price:{' '}
                    <a onClick={() => setFieldsValue({ price: price.last.toFixed(8) })}>
                        {price.last.toFixed(8)}
                    </a>
                    <br />
                    Ask:{' '}
                    <a onClick={() => setFieldsValue({ price: price.ask.toFixed(8) })}>
                        {price.ask.toFixed(8)}
                    </a>
                    <br />
                    Bid:{' '}
                    <a onClick={() => setFieldsValue({ price: price.bid.toFixed(8) })}>
                        {price.bid.toFixed(8)}
                    </a>
                </div>
            );
        }
        return null;
    }

    render() {
        const prices = this.props.store.botStore.marketStore.market;
        const bot = this.props.store.botStore.currentConfiguration;
        const baseBalance = this.props.store.botStore.balanceStore.getBalance(bot.base_currency);
        const liveTrades = this.props.store.botStore.positions;
        let max_exposure = 0;

        liveTrades
            .filter(o => o.active && o.status)
            .forEach(t => {
                max_exposure += t.max_cost || 0;
            });

        const baseAvailable =
            baseBalance < bot.base_allocation_total - max_exposure
                ? baseBalance
                : bot.base_allocation_total - max_exposure;
        const share = baseAvailable / 100;
        const symbols = Object.keys(prices)
            .map(p => prices[p])
            .filter(t => t.symbol.indexOf(bot.base_currency.toUpperCase()) >= 2);

        const { getFieldDecorator, setFieldsValue } = this.props.form;

        return (
            <Form>
                <Form.Item label="Symbol" required={true}>
                    {getFieldDecorator('market_id', {
                        rules: [{ required: true, message: 'Field is required' }]
                    })(
                        <Select showSearch>
                            {symbols.map(symbol => (
                                <Option value={symbol.name} key={symbol.name}>
                                    {symbol.name}
                                </Option>
                            ))}
                        </Select>
                    )}
                </Form.Item>

                {this.renderSelectedSymbolPrice()}

                <Form.Item label="Price" required={true}>
                    {getFieldDecorator('price', {
                        rules: [{ required: true, message: 'Field is required' }]
                    })(<Input type={'number'} style={{ width: '100%' }} precision={8} />)}
                </Form.Item>

                <Form.Item
                    label={`Position size: Available ${baseAvailable.toFixed(8)}`}
                    required={true}
                >
                    <ButtonGroup>
                        <Button
                            onClick={() =>
                                setFieldsValue({ position_size: (share * 5).toFixed(8) })
                            }
                        >
                            5%
                        </Button>
                        <Button
                            onClick={() =>
                                setFieldsValue({ position_size: (share * 10).toFixed(8) })
                            }
                        >
                            10%
                        </Button>
                        <Button
                            onClick={() =>
                                setFieldsValue({ position_size: (share * 25).toFixed(8) })
                            }
                        >
                            25%
                        </Button>
                        <Button
                            onClick={() =>
                                setFieldsValue({ position_size: (share * 50).toFixed(8) })
                            }
                        >
                            50%
                        </Button>
                        <Button
                            onClick={() =>
                                setFieldsValue({ position_size: (share * 75).toFixed(8) })
                            }
                        >
                            75%
                        </Button>
                        <Button
                            onClick={() =>
                                setFieldsValue({ position_size: (share * 100).toFixed(8) })
                            }
                        >
                            100%
                        </Button>
                    </ButtonGroup>

                    {getFieldDecorator('position_size', {
                        rules: [{ required: true, message: 'Field is required' }]
                    })(<Input addonAfter={bot.base_currency} style={{ width: '100%' }} />)}
                </Form.Item>

                <Form.Item label="Strategy" required={true}>
                    {getFieldDecorator('strategy_id', {
                        rules: [{ required: true, message: 'Field is required' }]
                    })(
                        <Select showSearch style={{ width: '100%' }}>
                            {this.props.store.strategyStore.buySell
                                .slice()
                                .sort((a, b) => {
                                    if (a.name < b.name) return -1;
                                    if (a.name > b.name) return 1;
                                    return 0;
                                })
                                .filter(s => !s.trigger)
                                .map(s => {
                                    return (
                                        <Option value={s.id} key={s.id}>
                                            {s.name}
                                        </Option>
                                    );
                                })}
                        </Select>
                    )}
                </Form.Item>
            </Form>
        );
    }
}

export const CreatePositionForm = Form.create()(CreatePositionFormComponent);



// WEBPACK FOOTER //
// ./src/Account/Bot/PositionsView/CreatePositionModal.js